import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
  Image,
} from 'react-native';
import { ms, s, vs } from '../../../../utils/responsive';
import { useNavigation, useRoute, RouteProp } from '@react-navigation/native';
import { RootStackNavigationProp, RootStackParamList } from '../../../../types/navigation';
import { BottomNavBar } from '../../../../components/BottomNavBar';

type FinancialPOALockedScreenRouteProp = RouteProp<RootStackParamList, 'FinancialPOALocked'>;

export const FinancialPOALockedScreen: React.FC = () => {
  const navigation = useNavigation<RootStackNavigationProp>();
  const route = useRoute<FinancialPOALockedScreenRouteProp>();

  const handleDone = () => {
    (navigation as any).navigate('EstatePlanning', { screen: 'EstatePlanningChecklist', params: { refreshKey: Date.now() } });
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity style={styles.backButton} onPress={() => navigation.goBack()}>
          <Image source={require('../../../../assets/icons/back.png')} style={[styles.backIcon, { tintColor: '#fff' }]} />
        </TouchableOpacity>
      </View>

      <View style={styles.topSection}>
        <Image source={require('../../../../assets/icons/keyimage.png')} style={styles.backgroundKey} />
        <Image source={require('../../../../assets/logo.png')} style={styles.logo} resizeMode="contain" />
      </View>

      <View style={styles.contentContainer}>
        <View style={styles.iconContainer}>
          <Image source={require('../../../../assets/icons/lock.png')} style={styles.lockIcon} />
        </View>

        <Text style={styles.title}>Your Financial POA is Private</Text>
        <Text style={styles.description}>
          Your financial power of attorney information is now locked and only accessible to you. You can change this setting at any time from your data screen.
        </Text>

        <TouchableOpacity style={styles.doneButton} onPress={handleDone}>
          <Text style={styles.doneButtonText}>Done</Text>
        </TouchableOpacity>
      </View>

      <BottomNavBar />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#29BFC0' },
  header: { flexDirection: 'row', alignItems: 'center', padding: ms(15), paddingTop: ms(25), position: 'relative' },
  backButton: { position: 'absolute', left: ms(50), padding: ms(15), paddingTop: ms(15), zIndex: 1 },
  backIcon: { width: s(32), height: s(32), tintColor: '#fff' },
  topSection: { alignItems: 'center', paddingVertical: ms(20) },
  backgroundKey: { position: 'absolute', width: '85%', height: '85%', opacity: 0.1 },
  logo: { width: s(80), height: s(80), marginBottom: ms(16) },
  contentContainer: { flex: 1, backgroundColor: '#F3F6F8', borderTopLeftRadius: ms(20), borderTopRightRadius: ms(20), paddingTop: ms(40), alignItems: 'center', paddingHorizontal: ms(20) },
  iconContainer: { width: s(80), height: s(80), borderRadius: ms(40), backgroundColor: '#FF9F64', alignItems: 'center', justifyContent: 'center', marginBottom: ms(30) },
  lockIcon: { width: s(40), height: s(40), tintColor: '#FFFFFF' },
  title: { fontSize: ms(24, 0.3), fontWeight: 'bold', color: '#1C2C4F', textAlign: 'center', marginBottom: ms(20) },
  description: { fontSize: ms(16, 0.3), color: '#6B7280', textAlign: 'center', lineHeight: ms(24, 0.3), marginBottom: ms(40), paddingHorizontal: ms(20) },
  doneButton: { backgroundColor: '#29BFC0', borderRadius: ms(25), paddingVertical: ms(15), paddingHorizontal: ms(60), alignItems: 'center' },
  doneButtonText: { color: '#FFFFFF', fontSize: ms(16, 0.3), fontWeight: '600' },
});
